<style lang="scss" scoped>
.title {
    color: #ffffff;
    letter-spacing: 0.05px;
    text-align: center;
    font-weight: bold;
}
.dash {
    display: flex;
    flex-flow: column;
    height: 56px;
    justify-content: space-between;
    span {
        width: 3px;
        background: #fff;
        height: 10px;
    }
}
.rte {
    ::v-deep h1 {
        color: #ffffff;
        font-size: 24px;
        font-weight: 800;
        letter-spacing: -0.58px;
        line-height: 35px;
        margin-bottom: 24px;
    }
    ::v-deep p {
        color: #ffffff;
        font-size: 18px;
        letter-spacing: -0.43px;
        line-height: 27px;
    }
}
</style>

<template>
    <section class="container mt-40 lg:mt-80">
        <h1 class="title mb-40 text-center text- text-34 lg:text-title-md">{{ data.title }}</h1>
        <div class="grid grid-cols-12" v-for="achievement in data.achievements" :key="achievement.id">
            <div class="hidden lg:block col-span-3"></div>
            <div class="flex flex-col items-center col-span-12 lg:col-span-6" :id="achievement.post_name" >
                <div class="dash">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <achievement :data="achievement" class="mt-120 w-level"></achievement>
                <div class="my-60 rte" v-html="achievement.acf.content"></div>
            </div>
            <div class="hidden lg:block col-span-3"></div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        data: {
            required: true,
            default: () => ({
                id: "",
                title: "",
                content: ""
            })
        }
    },
    methods: {
        nl2br(content) {
            if (!content) {
                return "";
            }
            return content.replace(/\n/g, "<br />");
        }
    }
};
</script>
